export default __webpack_public_path__ + "static/media/Sunset-Edited-960px-294px.jpg.33060aa2.webp";